import createModel, { prop } from 'models/lib/create_model';

export const ChatAction = createModel({
  modelName: 'ChatAction',

  properties: {
    id: prop(String).isRequired,
    type: prop(String).isRequired,
    label: prop(String),
    request: prop(String),
  },
});

export const ActionContext = createModel({
  modelName: 'ActionContext',

  properties: {
    type: prop(String).isRequired,
    name: prop(String),
    pageUrl: prop(String),
    primaryImageUrl: prop(String),
  },
});

export const ActionSelected = createModel({
  modelName: 'ActionSelected',

  properties: {
    sourceMessageId: prop(String).isRequired,
    action: prop(ChatAction).isRequired,
    context: prop(ActionContext).isRequired,
    renderedAt: prop(String),
  },
});
